var React = require('react');

function CarrotDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.93443 6.27694L2 2.33265L2.41415 1.9185L5.93443 5.43878L9.48429 1.88892L9.89844 2.31293L5.93443 6.27694Z","fill":"currentColor","stroke":"currentColor","strokeWidth":"2"}));
}

CarrotDown.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = CarrotDown;

CarrotDown.default = CarrotDown;
